import React from "react";
import { Icon, Text } from "@zorni/components-lib";

import styles from "./Timeline.module.css";

const TimelineNode = ({ status, label }) => {
  const isDone = status === "done";

  return (
    <div className={[styles.node, styles[`node-${status}`]].join(" ")}>
      <span className={[styles.dot, styles[`dot-${status}`]].join(" ")}>
        {isDone && <Icon name="iconCheck" size="sm" color="inherit" />}
      </span>
      <Text
        as="span"
        size="xs"
        weight="bold"
        className={[styles.label, styles[`label-${status}`]].join(" ")}
      >
        {label}
      </Text>
    </div>
  );
};

/**
 * Timeline horizontale générique : suite de repères ("done" | "current" |
 * "locked") reliés par une ligne, chacun avec un libellé. Ne connaît aucune
 * règle métier — réutilisable pour représenter la progression de n'importe
 * quel workflow (statut d'un organisme, d'un établissement…), l'appelant
 * fournit uniquement la liste des étapes.
 *
 * steps: Array<{ id: string, status: "done" | "current" | "locked", label: string }>
 */
const Timeline = ({ steps, className }) => (
  <div className={[styles.timeline, className].filter(Boolean).join(" ")}>
    {steps.map((step) => (
      <TimelineNode key={step.id} {...step} />
    ))}
  </div>
);

export default Timeline;
